<template>
  <v-container>
    <h1 class="text-center primary--text ">
      Produktionsplanung
    </h1>
    <ProductionInformation></ProductionInformation>
  </v-container>
</template>
<script>
import ProductionInformation from '../components/production/ProductionInformation'
export default {
  components: {
    ProductionInformation
  },
  data: () => ({
    content: {},
    rules: []
  }),
  created: function() {},
  methods: {}
}
</script>
